import {createElement, Component, PropTypes} from 'rlink-react';

class SocialShare extends Component {
  render () {
    return (
      <li className={'social-share-button'} onClick={ev => this.promptShareDialog(ev)}>
        <i className={`social-share-button ${this.props.fontAwesome.fa} ${this.props.fontAwesome[`fa-${this.props.vendor}`]} ${this.props.fontAwesome['fa-lg']}`} />
      </li>);
  }
}

export class FacebookShare extends SocialShare {

  promptShareDialog (ev) {
    ev.preventDefault();
    let shareUrl = this.props.shareUrl;
    if(typeof window.FB !== 'undefined')
    {
      window.FB.ui({
        method: 'share',
        href: shareUrl,
        quote: this.props.shareText,
      }, response => {});
    }
  }
}

FacebookShare.propTypes = {
  vendor: PropTypes.string,
};

FacebookShare.defaultProps = {
  vendor: 'facebook',
};

export class TwitterShare extends SocialShare {
  componentDidMount () {
    if (window.__twitterIntentHandler) {
      return;
    }
    let intentRegex = /twitter\.com\/intent\/(\w+)/,
      windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes',
      width = 550,
      height = 420,
      winHeight = screen.height,
      winWidth = screen.width;

    function handleIntent (e) {
      e = e || window.event;
      let target = e.target || e.srcElement,
        m, left, top;

      while (target && target.nodeName.toLowerCase() !== 'a') {
        target = target.parentNode;
      }

      if (target && target.nodeName.toLowerCase() === 'a' && target.href) {
        m = target.href.match(intentRegex);
        if (m) {
          left = Math.round((winWidth / 2) - (width / 2));
          top = 0;

          if (winHeight > height) {
            top = Math.round((winHeight / 2) - (height / 2));
          }

          window.open(target.href, 'intent', `${windowOptions},width=${width
                                             },height=${height},left=${left},top=${top}`);
          e.returnValue = false;
          e.preventDefault && e.preventDefault();
        }
      }
    }

    if (document.addEventListener) {
      document.addEventListener('click', handleIntent, false);
    } else if (document.attachEvent) {
      document.attachEvent('onclick', handleIntent);
    }
    window.__twitterIntentHandler = true;
  }

  promptShareDialog (ev) {
    ev.preventDefault();
    let shareUrl = this.props.shareUrl;
    let left, top,
      windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes',
      width = 550,
      height = 420,
      winHeight = screen.height,
      winWidth = screen.width;

    left = Math.round((winWidth / 2) - (width / 2));
    top = 0;

    if (winHeight > height) {
      top = Math.round((winHeight / 2) - (height / 2));
    }

    let intentURL = 'https://twitter.com/intent/tweet?';
    intentURL = `${intentURL}url=${encodeURIComponent(shareUrl)}`;
    intentURL = `${intentURL}&text=${encodeURIComponent(this.props.shareText)}`;

    window.open(intentURL, 'intent', `${windowOptions},width=${width},height=${height},left=${left},top=${top}`);
  }
}


TwitterShare.propTypes = {
  vendor: PropTypes.string,
};

TwitterShare.defaultProps = {
  vendor: 'twitter',
};



// WEBPACK FOOTER //
// ./lib/rlink-social-share/component.jsx